import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import { themeColor, themeSize, whenThemePropEqualsTrue } from '../../../theme/getters';
import { H1, paragraph, link } from '../../../theme/typography';
import { ExperienceSummary } from '../experienceSummary';
import { ExperienceSectionList } from '../experienceSectionList';
import { media } from '../../../theme/media';
import { ExperienceGallery } from '../experienceGallery';
import { contentPadding } from '../../../theme/mixins';
import { contentStyles } from '../../../theme/layout';

const whenIsPlaceholder = whenThemePropEqualsTrue('placeholder');

const containerPlaceholderStyle = whenIsPlaceholder(
  () => css`
    min-height: calc(100vh - ${themeSize('header')}px);
  `
);

const detailsPlaceholderStyle = whenIsPlaceholder(
  () => css`
    height: calc(100vh - ${themeSize('header')}px);
  `
);

const contentPlaceholderStyle = whenIsPlaceholder(
  () => css`
    padding-bottom: 0;
  `
);

export const Container = styled.section`
  background-color: ${themeColor('pink')};
  width: 100%;
  ${containerPlaceholderStyle};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding-bottom: 56px;

  ${media.tablet`
    padding: 0;
  `}

  ${media.desktopFull`
    ${contentStyles};
    padding-bottom: ${themeSize('contentPadding')}px;
  `}
  
  ${contentPlaceholderStyle};
`;

export const Half = styled.div`
  width: 100%;

  ${media.tablet`
    width: 50%;
    &:nth-child(2n) {
      padding-left: ${contentPadding}px;
    }
  `};

  ${media.desktopFull`
    padding-left: 56px;
  `};
`;

export const Details = styled(Half)`
  ${contentPadding};
  padding-top: 32px;
  text-align: left;

  ${media.tablet`
    ${contentPadding};
    padding-top: ${themeSize('contentPadding')}px;
    padding-bottom: 80px;
    max-width: 800px;
  `}

  ${detailsPlaceholderStyle};
`;

export const CoverContentWrapper = styled.div`
  ${media.tablet`
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - ${themeSize('header')}px - ${themeSize('contentPadding')}px * 2);
  `}
`;

export const MarketLink = styled(Link)`
  ${link};
  display: block;
  text-align: left;
  width: 100%;
  margin-bottom: 16px;
  text-decoration: none;
  text-transform: none;

  ${media.tablet`
    margin-bottom: 24px;
    text-transform: uppercase;
    margin: 0;
  `}
`;

export const Name = styled(H1)`
  margin: 0;
  flex: 1;
  display: flex;
  align-items: center;

  ${media.tablet`
    font-size: 60px;
    line-height: 1.15;
  `};
`;

export const Intro = styled.h2`
  ${paragraph};
  margin: 0;
`;

export const Summary = styled(ExperienceSummary)`
  margin: 0 0 32px;
`;

export const Description = styled.p`
  ${paragraph};
  margin: 32px 0 0;
`;

export const WeProvide = styled(ExperienceSectionList)`
  margin: 32px 0 0;
`;

export const GalleryWrapper = styled.div`
  position: sticky;
  top: ${themeSize('header')}px;

  ${media.desktopFull`
    top: calc(${themeSize('header')}px + ${themeSize('contentPadding')}px);
  `}
`;

export const Gallery = styled(ExperienceGallery)`
  width: 100%;
`;
